<div class="main-wrapper">
    <div class="act-search-bar">
        <app-search-bar (searchValue)="onSearchInput($event)" [value]="'faulty ECU builds'"
                        [newInputValue]="faultyEcuBuildsService.searchString()"></app-search-bar>
    </div>
    <div class="main" [class.has-selection]="faultyEcuBuild() !== null">
        <div class="faulty-table-wrapper">
            <app-faulty-ecu-builds-table [faultyEcuBuildList]="faultyEcuBuildsService.faultyEcuBuilds()"
                                         [selectedEcu]="faultyEcuBuild()"
                                         (faultyEcuBuild)="getFaultyEcuBuild($event)"/>
        </div>
        <div class="pure-original-table">
            @if (faultyEcuBuild() !== null) {
                <app-pure-original-faulty-ecu-table class="selected-records" [faultyEcuBuild]="faultyEcuBuild()"/>
            } @else {
                <div class="selection-placeholder"><i class="bi bi-list-check" aria-hidden="true"></i><h2>Select an ECU build</h2><p>Choose a name from the list to review its Pure Originals.</p></div>
            }

        </div>
    </div>
</div>
